import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['container'];

  flipImage(e) {
    this.containerTarget.classList.toggle('-flipped');
    e.target.classList.toggle('-flipped');
  }
}